import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {BlastSearchView, trackBlastTableAlignmentViewSwitch} from 'search/blast/BLASTTracking';
import {Operator} from 'search/SearchConstants';
import {ButtonSize} from 'ui-library/buttons/Button';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import ToggleGroup from 'ui-library/ToggleGroup';

import {SearchView} from './search-results/SearchResultsView';

export interface MultipleViewsToggleProps {
  viewSelection: SearchView;
  setViewSelection: (view: SearchView) => void;
  /* The toggle button is currently disabled for tblastx. */
  blastOperator: Operator;
}

export default function MultipleViewsToggle({
  viewSelection,
  setViewSelection,
  blastOperator,
}: MultipleViewsToggleProps): JSX.Element {
  return (
    <Tooltip
      isDisabled={blastOperator !== Operator.TBLASTX}
      text={<div className={css(styles.tooltip)}>Alignment view is currently unavailable for tblastx</div>}
    >
      <ToggleGroup<SearchView>
        options={[
          {id: SearchView.TABLE, buttonProps: {text: 'Table view'}},
          {
            id: SearchView.ALIGNMENT,
            buttonProps: {
              text: 'Alignment view',
              disabled: blastOperator === Operator.TBLASTX,
            },
          },
        ]}
        selection={viewSelection}
        onChangeSelection={(selection) => {
          trackBlastTableAlignmentViewSwitch(
            selection === SearchView.ALIGNMENT ? BlastSearchView.ALIGNMENT : BlastSearchView.TABLE
          );
          setViewSelection(selection);
        }}
        size={ButtonSize.MEDIUM}
      />
    </Tooltip>
  );
}

const styles = StyleSheet.create({
  tooltip: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '14px',
    textAlign: 'center',
  },
});
